<template>
    <div>
        <h2>Freizeitpartner finden</h2>

        <div class="form">
            <div class="form-group">
                <v-multiselect
                    placeholder="Stadt/PLZ"
                    :options="locations"
                    v-model="location"
                    track-by="zip"
                    label="label"
                    @search-change="searchLocations"
                    :preserve-search="true"
                    :preselect-first="true"
                    @open="this.location = null"
                    select-label=""
                    selected-label="Abwählen"
                    deselect-label="Abwählen"
                >
                    <template v-slot:noOptions>Keine Einträge</template>
                    <template v-slot:noResult>Es wurden keine Enträge gefunden</template>
                </v-multiselect>
            </div>

            <div class="form-group">
                <v-multiselect
                    placeholder="Entfernung"
                    :options="radiusList"
                    v-model="radius"
                    :searchable="false"
                    select-label=""
                    selected-label="Abwählen"
                    deselect-label="Abwählen"
                    :custom-label="value => value + ' km'"
                ></v-multiselect>
            </div>

            <div class="form-group" v-for="(category, index) in categories">
                <v-multiselect
                    :placeholder="category.name"
                    :options="category.children"
                    label="name"
                    track-by="id"
                    v-model="selectedCategories[index]"
                    :searchable="false"
                    select-label=""
                    selected-label="Abwählen"
                    deselect-label="Abwählen"
                ></v-multiselect>
            </div>

            <div class="pull-right">
                <button type="submit" class="btn btn-circle" @click="updatePartnerList"><span>Suche starten</span></button>
            </div>
        </div>
    </div>
</template>

<script>
import api from "../api";
import Multiselect from 'vue-multiselect'

export default {
    name: "FilterForm",

    components: {
        'v-multiselect': Multiselect,
    },

    data() {
        return {
            radiusList: [
                5,
                10,
                20,
                50,
                100,
                150,
                200,
            ],
            categories: [],
            locations: [],
            isLoadingLocations: false,
        }
    },

    computed: {
        partners() {
            return this.$store.state.partners;
        },

        location: {
            get() {
                return this.$store.state.location;
            },

            set(location) {
                this.$store.commit('setLocation', location);
            }
        },

        radius: {
            get() {
                return this.$store.state.radius;
            },

            set(radius) {
                this.$store.commit('setRadius', radius);
            }
        },

        selectedCategories: {
            get() {
                return this.$store.state.categories;
            },

            set(categories) {
                this.$store.commit('setCategories', categories);
            }
        },
    },

    async created() {
        let categories = await api.categories();

        categories = categories.filter(category => category.children.length > 0);

        this.selectedCategories = categories.map(c => null);

        this.categories = categories.map(category => {
            category.children.unshift({
                id: category.id,
                name: category.name,
                sort_number: 0
            });

            return category;
        });
    },

    methods: {
        updatePartnerList() {
            this.$store.dispatch('fetchPartners');
        },

        searchLocations(search) {
            this.isLoadingLocations = true;
            api.locations(search).then(locations => {
                this.locations = locations;
                this.isLoadingLocations = false;
            });
        },
    }
}
</script>
